import {
  isShipmentAdjustable,
  listItemsForPackage
} from 'profile/clubMembership/shipment/components/traditional/helpers';

import PackageItem from './PackageItem';

const ClubPackageInfo = (props) => {
  const { clubPackage, clubMemberShipment } = props;
  if (!isShipmentAdjustable(clubMemberShipment, clubPackage)) {
    return null;
  }
  const items = listItemsForPackage(clubMemberShipment, clubPackage);
  return (
    <>
      <div className="c7-account-row c7-account-row--basic">
        <h3>Club Options</h3>
        <p>
          Add from the items below to customize your club shipment.
          <br />
          <br />
        </p>
      </div>
      <div className="c7-products-club-shipment">
        {items.map((item) => (
          <PackageItem
            key={item.id}
            clubMemberShipmentId={clubMemberShipment.id}
            clubMemberShipment={clubMemberShipment}
            clubPackage={clubPackage}
            item={item}
          />
        ))}
      </div>
    </>
  );
};

export default ClubPackageInfo;
